
    import { enhanceAll } from './custom-select.js';
    function run() { try { enhanceAll(document); } catch (e) {} }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  